/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2020-07-03T15:07:15.566
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import util from '@/libs/util';
import router from '@/router';
import {
	getRentMaterialEditInit,
	getRentMaterialView
} from '@api/rentmanage/RentMaterial';

import {
	cloneObj
} from '@/plugins/utils'

import RespCommonDef from '@/plugins/utils/RespCommonDef'

export default {
	namespaced: true,
	state: {
		CompoundEntityDictionary: cloneObj(RespCommonDef.CompoundEntityDictionary)
	},
	actions: {
		getRentMaterialEditInit({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentMaterialEditInit({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},

		getRentMaterialView({
			state
		}, {
			id
		}) {
			return new Promise((resolve, reject) => {
				getRentMaterialView({
						id
					})
					.then(async res => {
						state.CompoundEntityDictionary = res;
						resolve(res.entityResponse);
					})
					.catch(err => {
						reject(err);
					})
			})
		},
	}
};
